import React, { useCallback, useState } from "react";
import fetch from "unfetch";
import { navigate } from "gatsby";
import { useLoads } from "react-loads";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Container, TextButton, Button, GiveMeSomeSpace } from "@util/standard";
import { Register } from "./register";
import { TextInput, MenuDrawer, IconButton } from "@global";
import { useStore } from "@state/store";
import { ForgotPassword } from "./forgotPassword";
import { updateCustomer } from "@util/getFirebase";

interface Props {
  visible: boolean;
}

const CloseContainer = styled(Container)`
  position: absolute;
  top: 20px;
  right: 15px;
`;

const Login = ({ visible }: Props) => {
  const form = React.createRef() as React.RefObject<HTMLFormElement>;
  const [showRegister, setShowRegister] = useState(false);
  const [showForget, setShowForget] = useState(false);
  const { closeDrawer, shopify } = useStore();
  const handleLogin = useCallback(async (email, password, shopifyObj) => {
    let data = {
      email,
      password,
      cartId: shopifyObj?.cart?.id,
    };
    const res = await fetch(`/api/login`, {
      method: "POST",
      body: JSON.stringify(data),
    });
    try {
      const response = await res.json();
      if (response.error) {
        console.error("login error", response);
        //Inform of incorrect email password
        toast.error(`Incorrect email or password.`);
        throw new Error(response.error);
      } else {
        //Successful
        updateCustomer(response, shopifyObj);
        setTimeout(() => {
          navigate("/account");
          closeDrawer();
        }, 400);
        toast.success(`Welcome back ${response.customer.firstName}!`);
        return null;
      }
    } catch (err) {
      throw err;
    }
  }, []);

  const { isPending, isReloading, load } = useLoads(
    "handleLogin",
    handleLogin as any,
    {
      defer: true,
    }
  );

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (form.current) {
      e.preventDefault();
      //@ts-ignore
      const { email, password } = form.current.elements;
      load(email.value, password.value, shopify);
    }
  };

  return (
    <MenuDrawer visible={visible} onClose={closeDrawer}>
      <CloseContainer>
        <IconButton icon="close" onClick={closeDrawer} />
      </CloseContainer>
      {showRegister ? (
        <Register setShowRegister={setShowRegister} />
      ) : (
        <>
          {showForget ? (
            <ForgotPassword setShowForget={setShowForget} />
          ) : (
            <Container
              height="100%"
              justifyContent="center"
              alignItems="center"
            >
              <form onSubmit={e => handleSubmit(e)} ref={form}>
                <h2>Sign In</h2>

                <div>
                  Don't have an account?{" "}
                  <TextButton
                    underlined
                    margin="0"
                    display="inline-block"
                    onClick={() => setShowRegister(true)}
                  >
                    Sign up
                  </TextButton>
                </div>

                <Container margin="30px 0 0 0" flexDirection="column">
                  <div>
                    <TextInput
                      name="email"
                      type="text"
                      required={true}
                      placeholder="Enter Email"
                      margin="0 0 20px 0"
                    />
                  </div>
                  <div>
                    <TextInput
                      name="password"
                      type="password"
                      required={true}
                      placeholder="Enter Password"
                      margin="0 0 20px 0"
                    />
                  </div>
                  <div>
                    <Button type="submit">
                      {isPending || isReloading ? "loading" : "Sign In"}
                    </Button>
                  </div>
                </Container>

                <div>
                  <GiveMeSomeSpace />
                  <TextButton
                    underlined
                    margin="0"
                    display="inline-block"
                    onClick={() => setShowForget(true)}
                  >
                    Forgot Password
                  </TextButton>
                </div>
              </form>
            </Container>
          )}
        </>
      )}
    </MenuDrawer>
  );
};

export default Login;